<template>
    <article class="item-wrapper">
        <header class="header" @click="toggle">
            <h1 class="title">
                <span
                    ><icon
                        :type="collapsed ? 'plus' : 'minus'"
                        color="#fea201"
                        size="1"
                /></span>
                {{ item.question }}
            </h1>
        </header>
        <div class="content" :class="{ collapsed: collapsed }">
            {{ item.answer }}
        </div>
    </article>
</template>

<script>
import Icon from '@/components/partials/IconRounded';

export default {
    name: 'FaqItem',
    components: { Icon },
    props: ['item'],
    data() {
        return {
            collapsed: true,
            question: '',
            answer: '',
        };
    },

    methods: {
        toggle() {
            this.collapsed = !this.collapsed;
        },
    },
};
</script>

<style lang="scss">
.table {
    width: 100%;
    text-align: left;
    margin-bottom: 2em;
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.item-wrapper {
    color: #727272;
    border-bottom: 1px solid #d3d3d3;
    margin-bottom: 1.5em;
    padding-bottom: 1.5em;
    width: 95%;
    @media (min-width: $xm-up) and (max-width: $xl-up) {
    }

    .header {
        cursor: pointer;

        .title {
            display: flex;
            flex-direction: row;
            align-items: center;
            width: 100%;
            height: 38px;
            color: #41566d;
            font-family: $palanquin-font;
            font-size: 21px;
            font-weight: 400;
            /* Text style for "y" */
            letter-spacing: -0.15px;
            @media (min-width: $xs-up) and (max-width: $xl-up) {
                width: 70%;
                height: auto;
                line-height: 29px;
            }
            @media (min-width: $xxs-up) and (max-width: $xs-up) {
                width: 70%;
                height: auto;
            }

            .icon-wrapper {
                margin-right: 1em;
            }
        }
    }

    .content {
        overflow: hidden;
        padding-left: 3.3em;
        max-height: 1000px;
        transition: max-height 1s ease-in;
        width: 100%;
        color: #41566d;
        font-family: $palanquin-font;
        font-size: 19px;
        font-weight: 400;
        letter-spacing: 0.1px;
        line-height: 22px;
        @media (min-width: $xs-up) and (max-width: $xl-up) {
            width: 90%;
            height: auto;
            margin-top: 2rem;
        }
        @media (min-width: $xxs-up) and (max-width: $xs-up) {
            width: 70%;
            height: auto;
            margin-top: 2rem;
        }

        &.collapsed {
            transition: max-height 0.5s;
            max-height: 0;
        }
    }
}
</style>
